(() => {
  const root = document.querySelector('[data-cya-yacht-detail]');
  if (!root) return;

  const embedded = document.getElementById("cya-yacht-data");
  const preload = embedded ? JSON.parse(embedded.textContent) : null;
  const params = new URLSearchParams(window.location.search);
  let yachtId = params.get('yacht');
  const apiBase = root.dataset.apiBase.replace(/\/$/, '');
  const loading = root.querySelector('[data-cya-loading]');
  const content = root.querySelector('[data-cya-content]');
  const mainImage = root.querySelector('[data-cya-main-image]');
  const mainButton = root.querySelector('[data-cya-main-button]');
  const thumbs = root.querySelector('[data-cya-thumbs]');
  const keyPhotos = root.querySelector('[data-cya-key-photos]');
  let activeQuoteUrl = '';
  const videoToggle = root.querySelector('[data-cya-video-toggle]');
  const lightbox = root.querySelector('[data-cya-lightbox]');
  const lightboxImage = root.querySelector('[data-cya-lightbox-image]');
  const galleryButton = root.querySelector('[data-cya-gallery-open]');
  const brochureButton = root.querySelector('[data-cya-brochure]');
  const pdfDialog = root.querySelector('[data-cya-pdf-dialog]');
  const pdfPages = root.querySelector('[data-cya-pdf-pages]');
  const pdfTitle = root.querySelector('[data-cya-pdf-title]');
  const pdfDownload = root.querySelector('[data-cya-pdf-download]');
  const pdfInquire = root.querySelector('[data-cya-pdf-inquire]');
  const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  let images = [];
  let activeImage = 0;
  let activeYacht;
  let activeYachtName = '';
  let pdfObjectUrl = '';

  const valueOf = (value) => {
    if (value == null || value === '') return '';
    if (typeof value === 'object') return value.label || value.name || value.title || '';
    return String(value);
  };
  const yachtSlug = (value) => String(value || '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const valuesOf = (value) => (Array.isArray(value) ? value : Object.values(value || {})).map(valueOf).filter(Boolean);
  const chooseCruisingArea = (seasons, areas, date, requested = '') => {
    if (areas.includes(requested)) return requested;
    const seasonalAreas = seasons
      .filter(season => (!season.start_date || season.start_date.slice(0, 10) <= date) && (!season.end_date || season.end_date.slice(0, 10) >= date))
      .flatMap(season => (season.location_areas || []).map(valueOf));
    return seasonalAreas.find(area => areas.includes(area)) || areas[0] || '';
  };
  const stripMarkup = (value) => {
    if (!value) return '';
    const container = document.createElement('div');
    container.innerHTML = String(value).replace(/<br\s*\/?>/gi, '\n');
    return (container.textContent || '').replace(/\n\s*\n+/g, '\n').trim();
  };
  const lengthLabel = (length, units) => {
    const value = Number(length);
    if (!Number.isFinite(value)) return '';
    const meters = String(units || '').toLowerCase().startsWith('meter');
    const feetValue = meters ? value * 3.28084 : value;
    const meterValue = meters ? value : value / 3.28084;
    return `${feetValue.toFixed(1).replace('.0', '')} ft (${meterValue.toFixed(1)} m)`;
  };
  const addDefinition = (list, label, value) => {
    if (!value || (preload && list.matches('[data-cya-key-facts],[data-cya-specifications],[data-cya-primary-specs]'))) return;
    const item = document.createElement('div');
    const term = document.createElement('dt');
    const description = document.createElement('dd');
    term.textContent = label;
    description.textContent = value;
    item.append(term, description);
    list.append(item);
  };
  const speedLabel = (value) => {
    const speed = valueOf(value);
    if (!speed) return '';
    return /(?:kt|knot)/i.test(speed) ? speed : `${speed} knots`;
  };
  const featureLabels = (items) => (Array.isArray(items) ? items : Object.values(items || {})).map((item) => {
    if (item == null) return '';
    if (typeof item !== 'object') return String(item);
    const label = item.label || item.name || item.title || item.description || '';
    if (!label) return item.notes ? stripMarkup(item.notes) : '';
    const quantity = Number(item.quantity) > 1 ? ` (${item.quantity})` : '';
    const notes = item.notes ? ` — ${stripMarkup(item.notes)}` : '';
    return `${label}${quantity}${notes}`;
  }).filter(Boolean);
  const renderFeatureSection = (sectionName, listName, copyName, items, copy) => {
    const labels = [...new Set(featureLabels(items))];
    const copyText = stripMarkup(copy);
    if (!labels.length && !copyText) return;
    root.querySelector(`[data-cya-${sectionName}-section]`).hidden = false;
    const copyElement = root.querySelector(`[data-cya-${copyName}-copy]`);
    if (copyText) {
      copyElement.hidden = false;
      copyElement.textContent = copyText;
    }
    const list = root.querySelector(`[data-cya-${listName}]`);
    labels.forEach((feature) => {
      const item = document.createElement('li');
      item.textContent = feature;
      list.append(item);
    });
  };
  const safeVideoUrl = (value) => {
    const raw = valueOf(value).replace(/&amp;/g, '&');
    if (!raw) return '';
    try {
      const url = new URL(raw, window.location.origin);
      if (url.protocol !== 'https:') return '';
      const host = url.hostname.replace(/^www\./, '');
      if (['youtube.com', 'youtube-nocookie.com', 'youtu.be'].includes(host)) {
        const id = host === 'youtu.be' ? url.pathname.split('/').filter(Boolean)[0] : url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop();
        return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? 'https://www.youtube.com/embed/' + id : '';
      }
      if (host === 'vimeo.com' || host === 'player.vimeo.com') {
        const parts = url.pathname.split('/').filter(Boolean);
        const index = parts.findIndex(part => /^\d+$/.test(part));
        if (index < 0) return '';
        const embed = new URL('https://player.vimeo.com/video/' + parts[index]);
        const hash = url.searchParams.get('h') || parts[index + 1];
        if (hash && /^[A-Za-z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
        return embed.href;
      }
      if (/\.(mp4|webm)$/i.test(url.pathname)) return url.href;
    } catch {}
    return '';
  };
  const selectKeyPhotos = (records) => {
    const chosen = [];
    if (records.length) chosen.push(0);
    for (const pattern of [/deck|flybridge|cockpit/i, /saloon|salon|interior|living/i, /cabin|stateroom|master/i]) {
      const index = records.findIndex((image, i) => !chosen.includes(i) && pattern.test(image.category + ' ' + image.caption + ' ' + image.src));
      if (index >= 0) chosen.push(index);
    }
    for (let index = 0; chosen.length < Math.min(4, records.length); index++) if (!chosen.includes(index)) chosen.push(index);
    return chosen;
  };
  const setActiveImage = (index) => {
    if (!images.length) return;
    activeImage = (index + images.length) % images.length;
    root.querySelectorAll('[data-image-index]').forEach(button => button.classList.toggle('is-active', Number(button.dataset.imageIndex) === activeImage));
    lightboxImage.src = images[activeImage].src;
    lightboxImage.alt = images[activeImage].alt;
  };
  const openLightbox = () => {
    if (!images.length) return;
    setActiveImage(activeImage);
    if (!lightbox.open) lightbox.showModal();
  };
  const imageData = async (url) => {
    const response = await fetch(`${apiBase}/api/image?url=${encodeURIComponent(url)}`);
    if (!response.ok) throw new Error('Photo download failed');
    const bitmap = await createImageBitmap(await response.blob());
    const canvas = document.createElement('canvas');
    canvas.width = 1500;
    canvas.height = 1000;
    const targetRatio = 1.5;
    const sourceRatio = bitmap.width / bitmap.height;
    let sx = 0; let sy = 0; let sw = bitmap.width; let sh = bitmap.height;
    if (sourceRatio > targetRatio) { sw = bitmap.height * targetRatio; sx = (bitmap.width - sw) / 2; }
    else { sh = bitmap.width / targetRatio; sy = (bitmap.height - sh) / 2; }
    canvas.getContext('2d').drawImage(bitmap, sx, sy, sw, sh, 0, 0, 1500, 1000);
    bitmap.close();
    return canvas.toDataURL('image/jpeg', .88);
  };
  const assetData = async (url) => {
    if (!url) return '';
    const response = await fetch(url);
    if (!response.ok) return '';
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => resolve('');
      reader.readAsDataURL(blob);
    });
  };
  let brochureLibraries;
  const loadLibrary = (src) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src; script.onload = resolve;
    script.onerror = () => { script.remove(); reject(new Error('The brochure is temporarily unavailable. Please try again.')); };
    document.head.append(script);
  });
  const createBrochure = async () => {
    if (!activeYacht || brochureButton.disabled) return;
    brochureButton.disabled = true;
    brochureButton.textContent = 'Preparing PDF…';
    pdfTitle.textContent = `${activeYachtName} PDF brochure`;
    pdfPages.innerHTML = '<p class="cya-yacht-detail__pdf-loading">Preparing brochure…</p>';
    if (!pdfDialog.open) pdfDialog.showModal();
    try {
      brochureLibraries ||= Promise.all([
        window.jspdf?.jsPDF ? Promise.resolve() : loadLibrary('https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js'),
        window.pdfjsLib ? Promise.resolve() : loadLibrary('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js')
      ]).catch(error => { brochureLibraries = null; throw error; });
      await brochureLibraries;
      const yacht = activeYacht;
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [210, 140] });
      const records = images.slice(0, 16);
      const prepared = [];
      for (const image of records) {
        try { prepared.push({ ...image, data: await imageData(image.src) }); } catch (error) { console.warn(error); }
      }
      if (!prepared.length) throw new Error('No brochure photos are available');
      const logo = await assetData(root.dataset.logoUrl);
      const footer = 'YCN Yachts | www.ycn.yachts | +1 818 640 4505 | contact@ycn.yachts';
      const addPhoto = (photo) => doc.addImage(photo.data, 'JPEG', 0, 0, 210, 140, undefined, 'FAST');
      const addBranding = () => {
        if (logo) doc.addImage(logo, 'PNG', 6, 5, 17, 17, undefined, 'FAST');
        doc.setFillColor(11, 38, 43); doc.rect(0, 132, 210, 8, 'F');
        doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor(255, 255, 255);
        doc.text(footer, 105, 137, { align: 'center' });
      };
      addPhoto(prepared[0]);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(31); doc.setTextColor(255, 255, 255);
      doc.text(activeYachtName, 202, 124, { align: 'right' }); addBranding();
      doc.addPage([210, 140], 'landscape'); addPhoto(prepared[1] || prepared[0]);
      doc.setFillColor(11, 38, 43); doc.rect(0, 0, 99, 132, 'F');
      doc.setTextColor(255, 255, 255); doc.setFontSize(21); doc.text('Overview', 10, 29);
      let y = 40;
      const writeRows = (title, rows) => {
        if (!rows.length || y > 120) return;
        doc.setFontSize(10.5); doc.text(title, 10, y); y += 6; doc.setFontSize(7.5);
        rows.forEach(([label, value]) => {
          if (!value || y > 126) return;
          const lines = doc.splitTextToSize(`${label}  ${value}`, 78);
          doc.text(lines, 13, y); y += (lines.length * 4) + 1;
        });
        y += 2;
      };
      writeRows('SPECIFICATIONS', [
        ['LENGTH', lengthLabel(yacht.lenght ?? yacht.length, yacht.units)],
        ['BEAM', lengthLabel(yacht.beam, yacht.units)], ['DRAFT', lengthLabel(yacht.draft, yacht.units)],
        ['YEAR', yacht.year_build], ['CRUISING SPEED', speedLabel(yacht.cruising_speed)], ['MAX SPEED', speedLabel(yacht.max_speed)]
      ]);
      writeRows('ACCOMMODATION', [['GUESTS', yacht.pax], ['CABINS', yacht.cabins]]);
      const toys = stripMarkup(yacht.other_toys);
      if (toys && y < 119) writeRows('TOYS', [['', toys]]);
      addBranding();
      prepared.slice(2).forEach((photo) => { doc.addPage([210, 140], 'landscape'); addPhoto(photo); addBranding(); });
      const buffer = doc.output('arraybuffer');
      if (pdfObjectUrl) URL.revokeObjectURL(pdfObjectUrl);
      pdfObjectUrl = URL.createObjectURL(new Blob([buffer], { type: 'application/pdf' }));
      pdfDownload.href = pdfObjectUrl;
      pdfDownload.download = `${activeYachtName}.pdf`.replace(/[\\/:*?"<>|]/g, '-');
      pdfInquire.href = activeQuoteUrl;
      pdfPages.innerHTML = '<p class="cya-yacht-detail__pdf-loading">Rendering brochure…</p>';
      if (!window.pdfjsLib) throw new Error('PDF viewer is unavailable');
      const pdf = await window.pdfjsLib.getDocument({ data: buffer, disableWorker: true }).promise;
      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1.35 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width; canvas.height = viewport.height;
        canvas.setAttribute('aria-label', `Brochure page ${pageNumber} of ${pdf.numPages}`);
        if (pageNumber === 1) pdfPages.replaceChildren();
        pdfPages.append(canvas);
        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
      }
    } finally {
      brochureButton.disabled = false;
      brochureButton.textContent = 'View brochure';
    }
  };

  root.querySelector('[data-cya-back]').addEventListener('click', () => {
    const returnTo = params.get('return_to');
    if (window.history.length > 1) window.history.back();
    else window.location.href = returnTo || root.dataset.catalogUrl;
  });
  root.querySelector('[data-cya-share]').addEventListener('click', async (event) => {
    const button = event.currentTarget;
    try {
      if (navigator.share) await navigator.share({ title: document.title, url: window.location.href });
      else { await navigator.clipboard.writeText(window.location.href); button.textContent = 'Link copied'; }
    } catch (error) {
      if (error.name !== 'AbortError') console.error('Share yacht:', error);
    }
  });
  mainButton.addEventListener('click', openLightbox);
  galleryButton.addEventListener('click', openLightbox);
  root.querySelector('[data-cya-lightbox-close]').addEventListener('click', () => lightbox.close());
  root.querySelector('[data-cya-previous]').addEventListener('click', () => setActiveImage(activeImage - 1));
  root.querySelector('[data-cya-next]').addEventListener('click', () => setActiveImage(activeImage + 1));
  lightbox.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
  brochureButton.addEventListener('click', () => createBrochure().catch((error) => {
    pdfPages.innerHTML = `<p class="cya-yacht-detail__pdf-loading">${error.message}</p>`;
    console.error('CYA PDF brochure:', error);
  }));
  root.querySelector('[data-cya-pdf-close]').addEventListener('click', () => pdfDialog.close());
  pdfDialog.addEventListener('click', (event) => { if (event.target === pdfDialog) pdfDialog.close(); });
  pdfDialog.addEventListener('close', () => {
    pdfPages.replaceChildren(); pdfDownload.removeAttribute('href'); pdfInquire.removeAttribute('href');
    if (pdfObjectUrl) { URL.revokeObjectURL(pdfObjectUrl); pdfObjectUrl = ''; }
  });

  async function loadYacht() {
    if (preload) yachtId = preload.yacht._id || preload.yacht.id;
    if (!apiBase) throw new Error('The yacht catalog is temporarily unavailable.');
    if (!yachtId) {
      const requestedSlug = decodeURIComponent(window.location.pathname.split('/').filter(Boolean).pop() || '');
      if (!requestedSlug || requestedSlug === 'yachts') throw new Error('A yacht was not selected.');
      const search = await fetch(`${apiBase}/api/yachts?q=${encodeURIComponent(requestedSlug.replace(/-/g, ' '))}&limit=24&sort_order=asc`);
      if (!search.ok) throw new Error('This yacht is temporarily unavailable.');
      const searchData = await search.json();
      const match = (searchData.yachts || []).find((item) => yachtSlug(item.yachtName || item.name) === requestedSlug);
      if (!match) throw new Error('This yacht could not be found.');
      yachtId = match.id || match._id;
    }
    const response = preload ? {ok:true,json:async()=>preload.yacht} : await fetch(`${apiBase}/api/yachts/${encodeURIComponent(yachtId)}`);
    if (!response.ok) throw new Error('This yacht is temporarily unavailable.');
    const yacht = await response.json();
    const name = yacht.yachtName || yacht.name || params.get('yacht_name') || 'Charter yacht';
    activeYacht = yacht;
    activeYachtName = name;
    const seasons = Array.isArray(yacht.seasons) ? yacht.seasons : [];
    const seasonWithPort = seasons.find((season) => season.base_port || season.preferred_pickup);
    const basePort = seasonWithPort?.base_port || seasonWithPort?.preferred_pickup || '';
    const areaLabels = preload?.seo.regions || [...new Set(seasons.flatMap((season) => (season.location_areas || []).map((area) => valueOf(area))).filter(Boolean))];
    const crew = Number(yacht.crewGeneral?.crewCount) || (Array.isArray(yacht.crewDetails) ? yacht.crewDetails.length : 0);
    const accommodations = yacht.accommodations || {};
    const builder = valueOf(yacht.builder) || valueOf(yacht.builder_name) || valueOf(yacht.shipyard);

    root.querySelectorAll("[data-cya-amenities],[data-cya-watersports],[data-cya-thumbs]").forEach(el=>el.replaceChildren());
    document.title = preload?.seo.title || `${name} Yacht Charter | YCN Yachts`;
    root.querySelector('[data-cya-name]').textContent = name;
    root.querySelector('[data-cya-model]').textContent = [builder, valueOf(yacht.model)].filter(Boolean).join(' ') || 'Private yacht charter';
    root.querySelector('[data-cya-price]').textContent = preload?.seo.priceLabel || (yacht.min_price_usd ? `From ${usd.format(yacht.min_price_usd)} USD / week` : 'USD rate on request');

    const primarySpecs = root.querySelector('[data-cya-primary-specs]');
    addDefinition(primarySpecs, 'Length (LOA)', lengthLabel(yacht.lenght ?? yacht.length, yacht.units));
    addDefinition(primarySpecs, 'Beam', lengthLabel(yacht.beam, yacht.units));
    addDefinition(primarySpecs, 'Draft', lengthLabel(yacht.draft, yacht.units));
    addDefinition(primarySpecs, 'Cruising speed', speedLabel(yacht.cruising_speed));
    addDefinition(primarySpecs, 'Max speed', speedLabel(yacht.max_speed));
    addDefinition(primarySpecs, 'Cabins', yacht.cabins ? `${yacht.cabins}` : valueOf(accommodations.cabins));
    if (!preload) root.querySelector('[data-cya-regions]').textContent = areaLabels.length ? `Cruising region: ${areaLabels.join(' · ')}` : '';

    const startDate = params.get('start_date');
    const days = params.get('available_days');
    const dates = root.querySelector('[data-cya-dates]');
    if (startDate || days) {
      dates.hidden = false;
      dates.textContent = [startDate ? `Start date: ${new Date(`${startDate}T00:00:00`).toLocaleDateString(preload?.seo.lang || 'en-US', { month: 'long', day: 'numeric', year: 'numeric' })}` : '', days ? `${days} day${days === '1' ? '' : 's'}` : ''].filter(Boolean).join(' · ');
    }

    const dateField = root.querySelector('[data-cya-start-date]');
    const daysField = root.querySelector('[data-cya-days]');
    const guestField = root.querySelector('[data-cya-guests]');
    const destinationField = root.querySelector('[data-cya-destination]');
    const today = new Date();
    dateField.min = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
    if (/^\d{4}-\d{2}-\d{2}$/.test(startDate || '')) dateField.value = startDate;
    if (/^([1-9]|[12][0-9]|30)$/.test(days || '')) daysField.value = days;
    const guestCount = params.get('guest_count') || '';
    if (/^\d+$/.test(guestCount) && Number(guestCount) >= 1 && Number(guestCount) <= 150) guestField.value = guestCount;
    if (Number(yacht.pax) > 0) guestField.max = String(Math.min(150, Number(yacht.pax)));
    const requestedArea = params.get('charter_destination') || '';
    for (const area of areaLabels) if (area && area.length <= 160) destinationField.add(new Option(area, area));
    if (areaLabels.includes(requestedArea)) destinationField.value = requestedArea;
    else destinationField.value = chooseCruisingArea(seasons, areaLabels, dateField.value || dateField.min);
    let areaChosenByVisitor = areaLabels.includes(requestedArea);
    destinationField.addEventListener('change', () => { areaChosenByVisitor = Boolean(destinationField.value); });
    dateField.addEventListener('input', () => {
      if (!areaChosenByVisitor) destinationField.value = chooseCruisingArea(seasons, areaLabels, dateField.value || dateField.min);
    });
    const updateQuoteLinks = () => {
      const quoteParams = new URLSearchParams({yacht: yachtId, yacht_name: name, charter_origin: 'cya-yacht-detail'});
      if (dateField.value) quoteParams.set('start_date', dateField.value);
      if (daysField.value) quoteParams.set('available_days', daysField.value);
      if (guestField.value) quoteParams.set('guest_count', guestField.value);
      if (destinationField.value) quoteParams.set('charter_destination', destinationField.value);
      activeQuoteUrl = root.dataset.quoteUrl + '?' + quoteParams;
      root.querySelectorAll('a[href*="/pages/quote"], [data-cya-inquire], [data-cya-inquire-secondary], [data-cya-pdf-inquire]').forEach(link => { link.href = activeQuoteUrl; });
    };
    root.querySelectorAll('.cya-yacht-detail__selection-fields input, .cya-yacht-detail__selection-fields select').forEach(field => ['input','change'].forEach(type => field.addEventListener(type, updateQuoteLinks)));
    root.querySelectorAll('[data-cya-inquire], [data-cya-inquire-secondary], [data-cya-pdf-inquire]').forEach(link => link.addEventListener('click', event => {
      if (![dateField, daysField, guestField].every(field => field.reportValidity())) event.preventDefault();
      updateQuoteLinks();
    }));
    updateQuoteLinks();
    window.addEventListener('pageshow', updateQuoteLinks);

    images = (Array.isArray(yacht.Images) ? yacht.Images : []).map((image, index) => ({
      src: image.image_src || image.src,
      category: image.category || '',
      caption: image.title || image.description || '',
      alt: preload?.seo.images[index]?.alt || image.title || `${name} yacht photo ${index + 1}`
    })).filter(image => { try { return new URL(image.src).protocol === 'https:'; } catch { return false; } });
    if (!images.length && (yacht.image || yacht.main_image)) images.push({src:yacht.image || yacht.main_image, alt:name, category:'', caption:''});
    root.querySelector('[data-cya-photo-count]').textContent = `${images.length} photo${images.length === 1 ? '' : 's'}`;
    const keyIndexes = selectKeyPhotos(images);
    const appendPhoto = (image, index, target) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.imageIndex = index;
      button.setAttribute('aria-label', image.alt);
      const thumbnail = document.createElement('img');
      thumbnail.src = image.src;
      thumbnail.alt = '';
      thumbnail.loading = 'lazy';
      thumbnail.width = 800; thumbnail.height = 600;
      button.append(thumbnail);
      button.addEventListener('click', () => { setActiveImage(index); openLightbox(); });
      target.append(button);
    };
    keyIndexes.forEach(index => appendPhoto(images[index], index, keyPhotos));
    images.forEach((image, index) => { if (!keyIndexes.includes(index)) appendPhoto(image, index, thumbs); });
    const allPhotos = root.querySelector('[data-cya-all-photos]');
    allPhotos.hidden = images.length <= 4;
    const label = root.querySelector('[data-cya-all-label]');
    const updatePhotoLabel = () => { label.textContent = allPhotos.open ? root.dataset.fewerPhotos : `${root.dataset.allPhotos} · ${images.length}`; };
    allPhotos.addEventListener('toggle', updatePhotoLabel); updatePhotoLabel();
    if (images.length) { mainImage.src = images[0].src; mainImage.alt = images[0].alt; setActiveImage(0); }
    else root.querySelector('.cya-yacht-detail__gallery-panel').hidden = true;

    const keyFacts = root.querySelector('[data-cya-key-facts]');
    addDefinition(keyFacts, 'Length overall', lengthLabel(yacht.lenght ?? yacht.length, yacht.units));
    addDefinition(keyFacts, 'Cabins', yacht.cabins ? `${yacht.cabins}` : valueOf(accommodations.cabins));
    addDefinition(keyFacts, 'Guests', yacht.pax ? `${yacht.pax}` : 'On request');
    addDefinition(keyFacts, 'Crew', crew ? `${crew}` : 'On request');

    const overview = (preload?.seo.overview || stripMarkup(valueOf(yacht.description) || valueOf(yacht.brochure) || valueOf(yacht.yacht_description))).replaceAll('YCN Miami', 'YCN Yachts');
    if (overview && !preload) {
      root.querySelector('[data-cya-overview-section]').hidden = false;
      root.querySelector('[data-cya-overview]').textContent = overview;
    }
    const overviewElement = root.querySelector('[data-cya-overview]');
    if (overviewElement.textContent.includes('YCN Miami')) overviewElement.textContent = overviewElement.textContent.replaceAll('YCN Miami', 'YCN Yachts');
    const overviewText = overview || overviewElement.textContent.trim();
    const words = overviewText.split(/\s+/);
    root.querySelector('[data-cya-intro]').textContent = words.slice(0, 55).join(' ') + (words.length > 55 ? '…' : '');
    root.querySelector('[data-cya-description]').hidden = words.length <= 55;
    const specs = root.querySelector('[data-cya-specifications]');
    addDefinition(specs, 'Builder', builder);
    addDefinition(specs, 'Model', valueOf(yacht.model));
    addDefinition(specs, 'Year', yacht.year_build ? `${yacht.year_build}${yacht.year_refit ? ` · Refit ${yacht.year_refit}` : ''}` : '');
    addDefinition(specs, 'Base port', basePort);
    addDefinition(specs, 'Guests', yacht.pax ? `${yacht.pax}` : '');
    addDefinition(specs, 'Crew', crew ? `${crew}` : '');

    const accommodationText = stripMarkup(valueOf(accommodations.accommodations_details) || valueOf(yacht.accommodation_details));
    if (accommodationText) {
      root.querySelector('[data-cya-accommodation-section]').hidden = false;
      root.querySelector('[data-cya-accommodation]').textContent = accommodationText;
    }
    const videoRecord = (Array.isArray(yacht.Videos) ? yacht.Videos : Array.isArray(yacht.videos) ? yacht.videos : [])
      .find(video => video && video.approve !== false && video.approve !== 'false' && safeVideoUrl(video.video_url || video.url || video.src));
    const videoUrl = videoRecord ? safeVideoUrl(videoRecord.video_url || videoRecord.url || videoRecord.src) : '';
    if (videoUrl) {
      const holder = root.querySelector('[data-cya-video]');
      const native = /\.(mp4|webm)(?:\?|$)/i.test(videoUrl);
      const player = document.createElement(native ? 'video' : 'iframe');
      let playing = false;
      let playUrl = videoUrl;
      if (native) {
        player.muted = true; player.loop = true; player.playsInline = true; player.preload = 'metadata';
        if (images.length) player.poster = images[0].src;
      } else {
        const embedUrl = new URL(videoUrl);
        for (const [key, value] of Object.entries({autoplay:'1', mute:'1', muted:'1', loop:'1', controls:'0', playsinline:'1'})) embedUrl.searchParams.set(key, value);
        if (embedUrl.hostname.includes('youtube')) embedUrl.searchParams.set('playlist', embedUrl.pathname.split('/').pop());
        else embedUrl.searchParams.set('background', '1');
        playUrl = embedUrl.href;
        player.title = videoRecord.title || name;
        player.allow = 'autoplay; encrypted-media; picture-in-picture';
        player.tabIndex = -1;
      }
      const setPlaying = (next) => {
        playing = next; holder.hidden = !next;
        videoToggle.textContent = next ? root.dataset.pauseVideo : root.dataset.playVideo;
        videoToggle.setAttribute('aria-pressed', String(!next));
        if (native) {
          if (next) { player.src ||= playUrl; player.play().catch(() => setPlaying(false)); } else player.pause();
        } else if (next) player.src = playUrl; else player.removeAttribute('src');
      };
      holder.replaceChildren(player); videoToggle.hidden = false;
      videoToggle.addEventListener('click', () => setPlaying(!playing));
      player.addEventListener('error', () => setPlaying(false));
      setPlaying(!matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    renderFeatureSection('watersports', 'watersports', 'watersports', yacht.watersports, yacht.other_toys);
    renderFeatureSection('amenities', 'amenities', 'amenities', yacht.amenities, yacht.other_entertainment);

    if (!root.querySelector('.cya-yacht-detail__detail-cards section:not([hidden])')) root.querySelector('.cya-yacht-detail__charter-details').hidden = true;
    loading.hidden = true;
    content.hidden = false;
    const mobileQuote = root.querySelector('[data-cya-mobile-quote]');
    const panelObserver = new IntersectionObserver(entries => {
      mobileQuote.hidden = entries.some(entry => entry.isIntersecting);
    });
    panelObserver.observe(root.querySelector('#cya-plan-charter'));
  }

  loadYacht().catch((error) => {
    loading.innerHTML = `<p>${error.message}</p><p><a href="${root.dataset.catalogUrl}">Return to the yacht catalog</a></p>`;
    console.error('CYA yacht detail:', error);
  });
})();



